import { render } from "./ScheduleView.vue?vue&type=template&id=2452a868&ts=true"
import script from "./ScheduleView.vue?vue&type=script&lang=ts"
export * from "./ScheduleView.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Github\\guardsonlinesms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__